<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Tarification Envois Express" />
            <ProduitEnvoisExpress />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'
import ProduitEnvoisExpress from '../Services/ProduitEnvoisExpress'
import FooterComp from '../Layouts/FooterComp'

export default {
    name: 'ProduitEnvoisExpressPage',
    components: {
        NavBar,
        PageTitle,
        ProduitEnvoisExpress,
        FooterComp,
    }
}
</script>